import { Callout, FormSection } from 'admination-react'
import { useVerbisLebenslaufUpload } from './useVerbisLebenslaufUpload'
import { VerbisLebenslaufBereich, VerbisLebenslaufUploadAction } from './VerbisLebenslaufHochladen'
import { VerbisLebenslaufFehlerPrompt } from './prompts'

export function VerbisLebenslaufNachreichen({ coachingId }: { coachingId: string }) {
  const upload = useVerbisLebenslaufUpload(coachingId)
  const { done, hinweise, ohneDatum } = upload
  const pruefen = hinweise.length > 0 || ohneDatum.length > 0

  return (
    <>
      {upload.statusError ? (
        <FormSection label="VerBIS und Lebenslauf">
          <Callout tone="error" role="alert">
            Ob VerBIS und Lebenslauf schon gespeichert sind, konnte nicht geladen werden. Bitte schließen Sie das Fenster und öffnen Sie es erneut.</Callout>
        </FormSection>
      ) : upload.statusLoading || (done.verbis && done.lebenslauf && !pruefen && !upload.uploading) ? null : (
        <VerbisLebenslaufBereich
          done={done}
          statusLoading={upload.statusLoading}
          uploading={upload.uploading}
          eintraege={upload.eintraege}
          hinweise={hinweise}
          ohneDatum={ohneDatum}
          onSaveZeitraum={upload.saveZeitraum}
          onAdd={upload.add}
          onRemove={upload.remove}
          actions={<VerbisLebenslaufUploadAction upload={upload} />}
          folgt
        />
      )}
      {upload.fehlerPrompt && (
        <VerbisLebenslaufFehlerPrompt
          meldung={upload.fehlerPrompt.meldung}
          fehler={upload.fehlerPrompt.fehler}
          onClose={upload.closeFehlerPrompt}
        />
      )}
    </>
  )
}
